<template>
  <div class="codelogin">
    <div>
      <div class="title">
        账号观看
      </div>
      <div class="input_view">
        <div class="phone_view">
          账号
          <input class="input_phone" placeholder="请输入账号" v-model="uphone"/>
        </div>
        <div style="font-size: 12px;padding-left: 120px;padding-top: 24px;">
          <span style="color: #4256FB;">忘记账号？</span><span>请联系直播管理员获取</span>
        </div>
      </div>
      <el-button class="sumbit" @click="send" :loading="show_pswloading">
        进入
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accountlogin',
  props: {
    logintype:Object
  },
  data() {
    return {
      uphone:'',
      nickname:'',
      show_pswloading:false
    }
  },
  methods: {
    send(){
      if(this.uphone.length <= 0){
        this.$message({
                message: "账号不能为空",
                type: "error"
            });
    }
    else{
      this.show_pswloading = true
      this.$liveapi.roomwatchytypephone(this.uphone).then(res=>{
      if(res.data.code == 200){
        this.show_pswloading = false
            this.nickname = res.data.data
            localStorage.setItem("user_name1", this.nickname)
            var nname = ""
            if(localStorage.getItem('iswx') == 0 && localStorage.getItem('logtpye') == 4){
              nname = res.data.data
            }
            this.$liveapi.getusertoken(nname,this.uphone,true).then(res=>{
            localStorage.setItem('room_token',res.data.data)
            localStorage.setItem("logintype", 0)
            this.$message({
                message: "验证成功",
                type: "success"
            });
              setTimeout(() => {
              location.reload()
            }, 1000);
          })
        }
        else{
          this.show_pswloading = false
        }
     }).catch(res=>{
          this.show_pswloading = false
     })
    }
    },
  },
 
}
</script>
<style scoped>
.codelogin{
    width: 392px;
    height: 500px;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1500);
    z-index: 2;
    background-color: #fff;
}
.title{
  padding-top: 52px;
  font-size: 20px;
  font-weight: 550;
  text-align: left;
  text-indent: 2em;
  /* margin-top: 20px; */
}
.input_view{
  width: 306px;
  margin: 45px auto;
}
.phone_view{
  padding-left: 16px;
  width: 300px;
  height: 46px;
  background: #EFF6FF;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}
.input_phone{
  width:200px;
  margin-left: 8px;
  font-size: 14px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}
.smscode_view{
  margin-top: 24px;
  width: 366px;
  height: 56px;
  text-align: left;
  font-size: 20px;
  color: #555555;
  line-height: 56px;
  border-radius: 5px;
}
.code_phone{
  float: left;
  width:214px;
  height: 56px;
  font-size: 18px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}
.smscode_view>div{
  float: right;
  width: 120px;
  height: 54px;
  border-radius: 5px;
  border: 1px solid #4256FB;
  text-align: center;
  color: #4256FB;
  font-size: 18px;
}
.sumbit{
  width: 306px;
  height: 46px;
  background: linear-gradient(171deg, #3EA2FF 0%, #4558FC 100%);
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  margin: 129px auto;
}
.slide_verify{
  position: absolute;
  bottom: 160px;
  z-index: 10;
}
</style>
